var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "record-package" },
    [
      !_vm.isapplets
        ? _c(
            "div",
            { staticClass: "header" },
            [
              _c("van-icon", {
                attrs: { name: "arrow-left", size: "20", color: "#333" },
                on: { click: _vm.goBack }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [_vm._v("学习记录")]),
              _vm._v(" "),
              _c("span", { staticClass: "exp" })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "record_content",
          on: {
            scroll: function($event) {
              return _vm.loadmore($event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "record_box" },
            [
              _vm.datalist && _vm.datalist.length == 0
                ? _c("div", { staticClass: "nodata" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("p", [_vm._v("暂无学习记录,请先去学习课程")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.datalist, function(i) {
                return _c(
                  "div",
                  { staticClass: "record_detail" },
                  [
                    i.day
                      ? _c("p", { staticClass: "record_date" }, [
                          _vm._v(_vm._s(i.day))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(i.list, function(item) {
                      return _c(
                        "div",
                        {
                          staticClass: "record_descript",
                          on: {
                            click: function($event) {
                              return _vm.godetail(item)
                            }
                          }
                        },
                        [
                          _c("p", { staticClass: "record_time" }, [
                            _vm._v(_vm._s(item.action_time))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "record_pathname" }, [
                            _vm._v(_vm._s(item.path_name))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "record_info" }, [
                            item.unit_type == 1 || item.unit_type == 7
                              ? _c("img", {
                                  attrs: {
                                    src: "static/images/doc.png",
                                    alt: ""
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.unit_type == 2
                              ? _c("img", {
                                  attrs: {
                                    src: "static/images/video.png",
                                    alt: ""
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.unit_type == 4 || item.unit_type == 5
                              ? _c("img", {
                                  attrs: {
                                    src: "static/images/write.png",
                                    alt: ""
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.unit_type == 6
                              ? _c("img", {
                                  attrs: {
                                    src: "static/images/zhibo.png",
                                    alt: ""
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.unit_type == 66
                              ? _c("img", {
                                  attrs: {
                                    src: "static/images/playback.png",
                                    alt: ""
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "record_type" }, [
                              _c("p", { staticClass: "record_name" }, [
                                _vm._v(_vm._s(item.unit_name) + " "),
                                _c("span")
                              ]),
                              _vm._v(" "),
                              item.unit_type == 1 || item.unit_type == 7
                                ? _c("p", { staticClass: "record_icon" }, [
                                    _vm._v("文档")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.unit_type == 2
                                ? _c("p", { staticClass: "record_icon" }, [
                                    _vm._v(
                                      "视频 | " +
                                        _vm._s(
                                          _vm._f("formatSeconds")(
                                            item.total_length
                                          )
                                        ) +
                                        " 已学习" +
                                        _vm._s(item.percentage)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.unit_type == 4 || item.unit_type == 5
                                ? _c("p", { staticClass: "record_icon" }, [
                                    _vm._v("练习")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.unit_type == 6
                                ? _c("p", { staticClass: "record_icon" }, [
                                    _vm._v(
                                      "直播  | " +
                                        _vm._s(
                                          _vm._f("timeFormat")(
                                            item.livingBeginTime
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("localDateH")(
                                            item.livingEndTime
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.unit_type == 66
                                ? _c("p", { staticClass: "record_icon" }, [
                                    _vm._v(
                                      "回放  | " +
                                        _vm._s(
                                          _vm._f("timeFormat")(
                                            item.livingBeginTime
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("localDateH")(
                                            item.livingEndTime
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.record_tip
            ? _c("p", { staticClass: "no_more" }, [_vm._v("没有更多记录了")])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.zujian_flag
        ? _c("div", { staticClass: "class_dialog" }, [
            _c("div", { staticClass: "dialog_box" }, [
              _c("div", { staticClass: "dialog_message" }, [
                _vm._v("手机浏览器暂不支持查看该课件"),
                _c("br"),
                _vm._v('你可在"' + _vm._s(_vm.appname) + '"进行查看')
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { on: { click: _vm.cancel_flag } }, [
                  _vm._v("取消")
                ]),
                _vm._v(" "),
                _vm.android
                  ? _c("span", { staticClass: "goapp" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: _vm.scheme },
                          on: { click: _vm.search_flag }
                        },
                        [_vm._v("打开APP")]
                      )
                    ])
                  : _vm.ios
                  ? _c(
                      "span",
                      { staticClass: "goapp", on: { click: _vm.search_flag } },
                      [_vm._v("去APP查看")]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("../../../static/images/record.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0843d86f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0843d86f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/record/record.vue
// module id = null
// module chunks = 